import { render, staticRenderFns } from "./EditorHeaderPresentingNoLeaderboard.vue?vue&type=template&id=65d455cd"
import script from "./EditorHeaderPresentingNoLeaderboard.vue?vue&type=script&lang=js"
export * from "./EditorHeaderPresentingNoLeaderboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports